module.exports = __webpack_public_path__ + "img/rmr_map.3fa1e77e.png";